export default __webpack_public_path__ + "static/media/ic-sort.c54f15b8.svg";